import { Component, Input } from '@angular/core';
import { LoggedUser } from "../../../auth/interfaces/logged-user";
import { AuthService } from "../../../auth/services/auth.service";
import { MenuItem } from "../../interfaces/menu-item";
import { Roles } from "../../helper/role";

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrl: './header.component.css',
    standalone: false
})
export class HeaderComponent {

  constructor(private authService: AuthService) { }

  @Input()
  loggedUser?: LoggedUser;

  headerMenu: MenuItem[] = [
    {
      title: 'Services',
      router: 'services/list',
      viewRoles: [Roles.ADMIN, Roles.USER]
    },
    {
      title: 'Thematic areas',
      router: 'categories/list',
      viewRoles: [Roles.ADMIN, Roles.USER]
    },
    {
      title: 'Tags',
      router: 'tags/list',
      viewRoles: [Roles.ADMIN, Roles.USER]
    },
    {
      title: 'Variables',
      router: 'variables/list',
      viewRoles: [Roles.ADMIN, Roles.USER]
    },
    {
      title: 'Spatial Extents',
      router: 'spatialExtents/list',
      viewRoles: [Roles.ADMIN, Roles.USER]
    },
    {
      title: 'Formats',
      router: 'formats/list',
      viewRoles: [Roles.ADMIN, Roles.USER]
    },
    {
      title: 'Crs',
      router: 'crss/list',
      viewRoles: [Roles.ADMIN, Roles.USER]
    },
    {
      title: 'Projections',
      router: 'projections/list',
      viewRoles: [Roles.ADMIN, Roles.USER]
    },
    {
      title: 'Sensors',
      router: 'sensors/list',
      viewRoles: [Roles.ADMIN, Roles.USER]
    },
    {
      title: 'Data Types',
      router: 'dataTypes/list',
      viewRoles: [Roles.ADMIN, Roles.USER]
    },
    {
      title: 'Data Tags',
      router: 'dataTags/list',
      viewRoles: [Roles.ADMIN, Roles.USER]
    },
    {
      title: 'Tutorial Categories',
      router: 'tutorialCategories/list',
      viewRoles: [Roles.ADMIN, Roles.USER]
    },
    {
      title: 'Tree Nodes',
      router: 'treeNodes/list',
      viewRoles: [Roles.ADMIN, Roles.USER]
    },
    {
      title: 'Target Audiences',
      router: 'targetAudience/list',   
      viewRoles: [Roles.ADMIN, Roles.USER]
    },
{
  title: 'Target Audiences–Thematic Areas',
  router: 'target-audiences-thematic-areas/list',
  viewRoles: [Roles.ADMIN, Roles.USER]
}
  ]

  async logout() {
    localStorage.removeItem('loggedUser');
    sessionStorage.removeItem('logged');
    await this.authService.logout();
  }
}
